










































import Vue from 'vue';

export default Vue.extend({
  name: 'QuizContentNavCard',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    prefixIcon: {
      type: Array,
      default: null,
    },
    prefixImage: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    iconSize: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasDuplicateListener() {
      return this.$listeners?.duplicate;
    },
    hasRemoveListener() {
      return this.$listeners?.remove;
    },
  },
  methods: {
    duplicate() {
      this.$emit('duplicate');
    },
    remove() {
      this.$emit('remove');
    },
  },
});
